import config from '../../config/config';

export const GATEWAYS_LOAD = 'GATEWAYS/GATEWAYS_LOAD';
export const GATEWAYS_SUCCESS = 'GATEWAYS/GATEWAYS_SUCCESS';
export const GATEWAYS_FAILURE = 'GATEWAYS/GATEWAYS_FAILURE';

export function getGatewaysFailureActionCreator(error) {
    return {
        error,
        type: GATEWAYS_FAILURE
    };
}

export function getGatewaysSuccessActionCreator(gateways) {
    return {
        gateways,
        type: GATEWAYS_SUCCESS
    };
}

export function getGateways() {

    return {
        failureActionTypeOrCreator: getGatewaysFailureActionCreator,
        fetchParams: {
            url: `${config.paymentApiUrl}/getGatewayList`
        },
        loadActionTypeOrCreator: GATEWAYS_LOAD,
        successActionTypeOrCreator: getGatewaysSuccessActionCreator
    };
}
